import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, Select, Form } from "antd";
import { debounce } from "lodash";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const { Option } = Select;

const FormFields = () => {
  const { governments, regions, loading } = useSelector(
    (state) => ({
      governments: state.governments.governments,
      regions: state.regions.regions,
      loading: {
        persons: state.persons.loading,
        governments: state.governments.loading,
        regions: state.regions.loading,
      },
    })
  );
  const [search, setSearch] = useState({
    government: "",
    region: "",
  });
  const [ids, setIds] = useState({
    government: "",
    region: "",
  });

  const dispatch = useDispatch();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce((value, key) => {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: value,
      }));
    }, 300),
    [] // Dependencies
  );

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 50, search: search.government }));
  }, [search.government, dispatch]);

  useEffect(() => {
    const selectedGovernmentId = ids.government || null;
    dispatch(
      getRegions({
        page: 1,
        itemsPerPage: 50,
        governmentId: selectedGovernmentId,
        search: search.region || "",
      })
    );
  }, [ids.government, search.region, dispatch]);

  const handleSearchedValue = (value, key) => {
    debounceSearch(value, key);
  };

  const handleSelect = (key, id) => {
    setIds((prevId) => ({
      ...prevId,
      [key]: id,
    }));
  };

  return (
    <div>
      {loading.persons && <p>Chargement...</p>}

      {[
        { name: "firstname", label: "Nom", placeholder: "Nom" },
        { name: "lastname", label: "Prénom", placeholder: "Prénom" },
        { name: "pharmacyName", label: "Nom de la pharmacie", placeholder: "Nom de la pharmacie" },
        { name: "email", label: "Email", placeholder: "Email" },
        { name: "phone", label: "Téléphone", placeholder: "Téléphone" },
        { name: "address", label: "Adresse", placeholder: "Adresse" },
      ].map(({ name, label, placeholder }) => (
        <Form.Item
          key={name}
          name={name}
          label={label}
          rules={[
            { required: true, message: `Veuillez entrer ${label.toLowerCase()}` },
          ]}
        >
          <Input placeholder={placeholder} />
        </Form.Item>
      ))}
      <Form.Item
        name="government"
        label="Gouvernorat"
        rules={[{ required: true, message: "Veuillez sélectionner le gouvernorat" }]}
      >
        <Select
          placeholder={loading.governments ? "Chargement..." : "Choisir un gouvernorat"}
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          loading={loading.governments}
        >
          {governments?.data?.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>

      </Form.Item>

      <Form.Item
        name="region"
        label="Région"
        rules={[{ required: true, message: "Veuillez sélectionner une région" }]}
      >
        <Select
          placeholder={loading.regions ? "Chargement..." : "Choisir une région"}
          loading={loading.regions}
          showSearch
          onSearch={(e) => handleSearchedValue(e, "region")}
          onSelect={(e) => handleSelect("region", e)}
          filterOption={false}
        >
          {regions?.data?.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Veuillez sélectionner un type" }]}
      >
        <Select placeholder="Choisir un type">
          <Option value={1}>Pharmacie de jour</Option>
          <Option value={2}>Pharmacie de nuit</Option>
        </Select>
      </Form.Item>
    </div>
  );
};

export default FormFields;
